<template>
  <full-page ref="fullpage" :options="options" id="fullpage">
    <!-- Section 1 | Willkommen -->
    <div id="start" class="section fp-noscroll d-flex flex-column align-items-center justify-content-end">
      <transition name="slide-fade" appear>
        <div ref="section1" v-if="this.section1" class="d-flex flex-column align-items-center justify-content-center" :style="{ height: section1ContentHeight + 'px'}">
          <div class="gr-title-text px-5 d-flex flex-column justify-content-center">
            <h3>Herzlich willkommen in der</h3>
            <h1 class="gr-header-1">Goldschmiede Goldregen</h1>
            <h3>Ladenwerkstatt für Schmuck in München</h3>
            <div class="mt-3 mt-sm-4 d-flex justify-content-center">
              <gr-btn-lite text="schmuckstücke ansehen" @click.native="$routePush('schmuckstuecke')"></gr-btn-lite>
            </div>
          </div>
        </div>
      </transition>
      <div style="width: 100%">
        <img class="gr-split-img gr-split-img-lg-top" :style="{ height: get35vh + 'px' }" src="@/assets/imgs/goldschmiede_ladenwerkstatt.jpg"
             alt="Innenansicht der Goldschmiede mit Goldschmuck" v-on:load="imageDownloadFinished(1)">
      </div>
    </div>
    <!-- Section 2 | Goldschmiede -->
    <div class="section fp-noscroll gr-section-wrapper gr-section-wrapper-lg-column">
      <div style="width: 100%">
        <img class="gr-split-img gr-split-img-lg-btm" :style="{ height: get35vh + 'px' }" src="@/assets/imgs/goldschmiede_ladenwerkstatt_innen.jpg" alt="Innenansicht der Goldschmiede mit Goldschmuck" v-on:load="imageDownloadFinished(2)">
      </div>
      <div class="gr-content-container-home gr-content-container-lg-row gr-noscrollable-65vh" :style="sectionOtherContentHeight">
        <div class="gr-text-container gr-text-container-lg-row px-4">
          <transition name="slide-fade" appear>
            <div v-if="this.section2">
              <h2 class="gr-header-2">Goldschmiede</h2>
              <div class="gr-p-container">
                <p>All unsere Schmuckstücke werden in unserer Ladenwerkstatt in
                München-Schwabing von Hand gefertigt.
                Bei einem Besuch können Sie sich unseren Schmuck
                ansehen und bekommen gleichzeitig einen Einblick in das traditionsreiche Handwerk des Goldschmieds,
                da unsere Werktische direkt im Laden stehen.</p>
              </div>
              <gr-btn-lite text="mehr erfahren" backgroundColor="rose" @click.native="$routePush('goldschmiede')"></gr-btn-lite>
            </div>
          </transition>
        </div>
        <div class="gr-content-img-container" v-if="isDesktopOrIpad">
          <img class="gr-content-img-horizontal" style="object-position: 50% 100%" src="@/assets/imgs/goldring_anfertigung.png" alt="Goldring – individuelle Anfertigung in der Goldschmiede" loading="lazy" decoding="async">
        </div>
      </div>
    </div>
    <!-- Section 3 | Unsere Schmuckstücke  -->
    <div class="section fp-noscroll gr-section-wrapper gr-section-wrapper-lg-row">
      <div>
        <img class="gr-main-img" src="@/assets/imgs/ringe.jpeg" alt="Individueller Goldring" v-on:load="imageDownloadFinished(3)">
      </div>
      <div class="gr-content-container-home gr-content-container-lg-column gr-noscrollable-65vh" :style="sectionOtherContentHeight">
        <div class="gr-text-container gr-text-container-lg-column px-4">
        <transition name="slide-fade" appear>
          <div v-if="this.section3">
            <h2 class="gr-header-2">Unsere Schmuckstücke</h2>
            <div class="gr-p-container">
              <p>Sehen Sie sich hier eine Auswahl unserer Schmuckstücke an. Vom Entwurf bis zum letzten
                Schliff werden die Stücke in unserer Werkstatt handgefertigt.</p>
            </div>
            <gr-btn-lite text="mehr erfahren" @click.native="$routePush('schmuckstuecke')"></gr-btn-lite>
          </div>
          </transition>
        </div>
        <div class="gr-content-img-container mt-lg-4" v-if="isDesktopOrIpad">
          <img class="gr-content-img" style="object-position: 80% 100% !important" src="@/assets/imgs/goldkette.png" alt="Handgefertigte Goldkette" loading="lazy" decoding="async">
        </div>
      </div>
    </div>
    <!-- Section 4 | Individuelles -->
    <div class="section gr-section-wrapper gr-section-wrapper-lg-row">
      <div class="order-lg-2">
        <img class="gr-main-img gr-main-img-15" src="@/assets/imgs/goldschmiede.jpg" v-on:load="imageDownloadFinished(4)" alt="Handarbeit in der Goldschmiede">
      </div>
      <div class="order-lg-1 gr-content-container-home gr-content-container-lg-column gr-noscrollable-65vh" :style="sectionOtherContentHeight">
        <div class="gr-text-container gr-text-container-lg-column px-4">
          <transition name="slide-fade" appear>
            <div v-if="this.section4">
              <h2 class="gr-header-2">Individuelles</h2>
              <div class="gr-p-container">
                <p>In unserer Werkstatt fertigen wir vieles ganz individuell
                  nach Ihren Vorstellungen und Wünschen an oder arbeiten bestehenden Schmuck in neue Stücke um.
                  Bei allen individuellen Anfertigungen ist es möglich, Ihr Altgold zu verwenden.</p>
              </div>
              <gr-btn-lite text="mehr erfahren" backgroundColor="rose" @click.native="$routePush('individuelles')"></gr-btn-lite>
            </div>
          </transition>
        </div>
        <div class="gr-content-img-container-strech mt-lg-4" v-if="isDesktopOrIpad">
          <img class="gr-content-img" src="@/assets/imgs/goldkette_gruen.png" alt="Goldkette mit Edelstein" loading="lazy" decoding="async">
        </div>
      </div>
    </div>
    <!-- Section 5 | Kontakt -->
    <div class="section">
      <div class="gr-section-wrapper gr-section-wrapper-lg-row gr-sm-scrollable" style="height: 100%">
        <div>
          <img class="gr-main-img gr-main-img-60" src="@/assets/imgs/laden.jpg" alt="Außenansicht der Goldschmiede Goldregen in München-Schwabing" loading="lazy" decoding="async">
        </div>
        <div class="gr-content-container-home align-self-lg-center gr-scrollable h-100">
          <div class="gr-text-container gr-text-container-lg-column px-4">
            <transition name="slide-fade" appear>
              <div v-if="this.section5">
                <h2 class="gr-header-2">Finden Sie uns</h2>
                <div class="gr-p-container">
                  <p>Belgradstr. 136</p>
                  <p>80804 München</p>
                  <p>Telefon: <a href="tel:089-45209288" style="text-decoration: none;;">089 - 45 20 92 88</a></p>
                  <p>Email: info@goldregen-muenchen.de</p>
                  <p style="margin-top: 10px">Haltestelle: Scheidplatz für Ubahn, Tram und Bus
                  </p>
                  <div class="d-flex flex-row py-4">
                    <a target="_blank" href="https://goo.gl/maps/5h8NaW5u3mdTUZFQ7" aria-label="Google Maps – Standort der Goldschmiede Goldregen" rel="noopener">
                      <img style="max-height: 25px; margin: 0 15px;" src="@/assets/imgs/maps.png" alt="Google Maps" loading="lazy">
                    </a>
                    <a target="_blank" href="https://www.instagram.com/goldschmiede_goldregen/" aria-label="Goldschmiede Goldregen auf Instagram" rel="noopener">
                      <img style="max-height: 25px; margin: 0 15px;" src="@/assets/imgs/instagram.png" alt="Instagram" loading="lazy">
                    </a>
                    <a target="_blank" href="https://de-de.facebook.com/GoldschmiedeGoldregen" aria-label="Goldschmiede Goldregen auf Facebook" rel="noopener">
                      <img style="max-height: 25px; margin: 0 15px;" src="@/assets/imgs/facebook.png" alt="Facebook" loading="lazy">
                    </a>
                  </div>
                </div>
                <h2 class="gr-header-2">Öffnungszeiten</h2>
                <div class="gr-p-container" style="margin-bottom: 0 !important;">
                  <div class="d-flex flex-column py-2">
                    <p style="font-weight: 500">Di., Do., Fr.</p>
                    <p>10.00 - 13.00 + 14.00 - 19.00 Uhr</p>
                  </div>
                  <div class="d-flex flex-column py-2">
                    <p style="font-weight: 500">Mi.</p>
                    <p>12.00 - 19.00 Uhr</p>
                  </div>
                  <div class="d-flex flex-column py-2">
                    <p style="font-weight: 500">Sa.</p>
                    <p>11.00 - 14.00 Uhr</p>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div class="section fp-auto-height">
      <AppFooter></AppFooter>
    </div>
  </full-page>
</template>

<script>
import grBtnLite from '@/components/grBtnLite'
import 'fullpage.js/vendors/scrolloverflow'
import AppFooter from './../layout/Footer'
import { colors, timeout } from './../config'
import axios from 'axios'

export default {
  name: 'IndexPage',

  components: {
    grBtnLite,
    AppFooter
  },
  data () {
    return {
      isToast: false,
      options: {
        licenseKey: '95185C31-0387415E-A00FCDD6-E9FB6DEE',
        menu: '#menu',
        anchors: ['willkommen', 'goldschmiede', 'schmuckstuecke', 'individuelles', 'kontakt', 'footer'],
        sectionsColor: [colors.turquise, colors.rose, colors.turquise, colors.rose, colors.turquise],
        verticalCentered: false,
        scrollOverflow: true,
        onLeave: this.onLeave
      },
      isNewLoading: true,
      isImageLoading1: true,
      isImageLoading2: true,
      isImageLoading3: true,
      isImageLoading4: true,
      isImageLoading5: true,
      imgContainerHeight: 0,
      textContainerHeight: 0,
      section1ImgVisible: 'hidden',
      section1: true,
      section2: false,
      section3: false,
      section4: false,
      section5: false,
      window: {
        width: 0,
        height: 0
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.isNewLoading = true
    this.setLoading(true)
  },
  mounted () {
    document.body.style.height = 'auto'
    this.handleResize()
  },
  beforeMount () {
    this.isNewLoading = false
    setTimeout(() => {
      this.setLoading(false)
      this.setTextVisible()
    }, timeout.bigTimeout)
    this.checkNachricht()
  },
  beforeDestroy () {
    this.$store.commit('setHeader', true)
    // Clean up global styles that fullpage.js sets on html/body
    document.documentElement.style.overflow = ''
    document.documentElement.style.height = ''
    document.body.style.overflow = ''
    document.body.style.height = ''
    document.documentElement.classList.remove('fp-enabled')
  },
  computed: {
    section1ContentHeight () {
      return Math.round(this.window.height * 0.65 - this.$store.getters['dom/navBarHeight'])
    },
    get35vh () {
      return this.window.height * 0.35
    },
    sectionOtherContentHeight () {
      return this.isDesktopOrIpad && { height: Math.round(this.window.height - Math.min(65, this.$store.getters['dom/navBarHeight'])) + 'px !important' }
    },
    isDesktopOrIpad: function () {
      return !this.$store.getters['dom/isTablet']
    },
    isLoading: function () {
      return !this.$store.getters['loading/isLoadingApp']
    }
  },
  methods: {
    imageDownloadFinished (id) {
      switch (id) {
        case 1:
          this.isImageLoading1 = false
          break
        case 2:
          this.isImageLoading2 = false
          break
        case 3:
          this.isImageLoading3 = false
          break
        case 4:
          this.isImageLoading4 = false
          break
        case 5:
          this.isImageLoading5 = false
          break
      }
      setTimeout(() => {
        this.setLoading(false)
      }, timeout.smallTimeout)
    },
    setLoading (isLoaded) {
      if ((this.isImageLoading1 && this.isImageLoading2 && this.isNewLoading) ||
        (!this.isImageLoading1 && !this.isImageLoading2 && !this.isNewLoading)) {
        this.$store.commit('loading/SET_LOADING_APP', isLoaded)
      }
    },
    setTextVisible () {
      try {
        const activeSection = this.$parent.$children[1].$refs.fullpage.api.getActiveSection()
        if (activeSection && activeSection.index > 0 && (!this.section2 && !this.section3 && !this.section4 && !this.section5)) {
          this.section1 = this.section2 = this.section3 = this.section4 = this.section5 = true
        }
      } catch (e) {
        // fullpage API not ready yet, sections will be set via onLeave
      }
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
      if (this.window.width < 992) {
        this.imgContainerHeight = this.window.height * 0.35
        this.textContainerHeight = (this.window.height - 80) * 0.65
      } else {
        this.imgContainerHeight = this.window.height * 0.40
        this.textContainerHeight = (this.window.height - 110) * 0.60
      }
    },
    onLeave: function (origin, destination, direction) {
      origin.index > destination.index ? this.$store.commit('setHeader', true) : this.$store.commit('setHeader', false)
      setTimeout(() => {
        this.section1 = destination.index >= 0
        this.section2 = destination.index >= 1
        this.section3 = destination.index >= 2
        this.section4 = destination.index >= 3
        this.section5 = destination.index >= 4
      }, 200)
    },
    async checkNachricht () {
      try {
        const response = await axios.get('/news.json', { params: { _t: Date.now() } })
        if (response.data.nachricht && response.data.nachricht.trim() !== '') {
          this.$store.commit('toast/NEW', response.data.nachricht.trim())
        }
      } catch (error) {
        console.error('Error fetching news.json:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  p {
    margin-bottom: 0;
  }
  .gr-section-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .gr-content-container-home {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .gr-noscrollable-65vh {
    height: 65vh;
  }
  .gr-text-container {
    line-height: 1.1;
  }
  h3 {
    font-family: $font-content;
    font-size: 0.95em;
    line-height: 1.7;
    margin-bottom: 0 !important;
    font-weight: 400;
    letter-spacing: 0.01em;
  }
  .gr-p-container {
    margin-bottom: 0.5rem;
  }
  p {
    font-size: 0.95em;
    line-height: 1.7;
  }
  .gr-title-text {
    line-height: 1.1;
  }
  .gr-main-img {
    object-fit: cover;
    width: 100%;
    height: 35vh;
  }
  .gr-main-img-15 {
    object-position: 100% 15%;
  }
  .gr-main-img-60 {
    object-position: 100% 60%;
  }
  .gr-split-img {
    object-fit: cover;
    width: 100%;
    object-position: 40% 100%;
  }
  .gr-content-img-container {
    display: flex;
    justify-content: center;
  }
  .gr-content-img-container-strech {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .gr-content-img {
    width: 100%;
    height: 9vh;
    max-height: 85px;
    object-fit: cover;
    object-position: 0% 100%;
  }
  .gr-content-img-horizontal {
    height: 5vh;
    max-height: 85px;
    object-fit: cover;
    object-position: 0% 100%;
  }
  @media(max-height: 820px) {
    .gr-scrollable {
      min-height: 590px !important;
      height: 100%;
    }
  }
  @media(max-height: 440px) {
    h3 {
      font-size: 0.8em !important;
    }
  }
  @media(min-height: 420px) and (max-height: 450px) {
    p {
      font-size: 0.9em !important;
    }
  }
  @media(max-height: 420px) and (min-width: 310px) {
    p {
      font-size: 0.8em !important;
    }
  }
  @media (max-height: 375px) and (max-width: 310px) {
    p {
      font-size: 0.7em !important;
    }
  }
  @media(min-width: 760px) {
    .gr-text-container-lg-column {
      max-width: 80vw;
      // prevent that on transition potential image below text-container moves
      min-height: 25vh;
    }
    .gr-p-container {
      margin-bottom: 1rem;
    }
  }
  @media(min-width: 760px) and (max-width: 1025px) {
    .gr-text-container {
      max-width: 80vw !important;
      min-height: 25vh !important;
    }
    .gr-content-img {
      object-position: 20% 100% !important;
    }

  }
  @media(max-width: 1023px) {
    .gr-scrollable {
      min-height: 590px !important;
    }
  }
  @media(min-width: $window-lg) {
    .gr-scrollable {
      max-height: 100vh;
    }
    .gr-text-container-lg-column {
      max-width: 35vw;
      min-height: 35vh;
    }
    .gr-text-container-lg-row {
      max-width: calc(min(45vw, 750px));
      min-width: 25vw;
      margin-bottom: 0 !important;
    }
    .gr-section-wrapper-lg-row {
      flex-direction: row;
      justify-content: flex-start;
    }
    .gr-section-wrapper-lg-column {
      flex-direction: column;
      justify-content: flex-start;
    }
    .gr-content-container-lg-column {
      align-self: flex-end;
    }
    .gr-content-container-lg-row {
      flex-direction: row;
    }
    .gr-content-img-horizontal {
      margin: 5vw;
    }
    p {
      font-size: 1.1em;
    }

    h3 {
      font-size: 1.1em;
    }
    .gr-main-img {
      object-position: 50% 50%;
      width: 40vw;
      height: 100%;
      flex: 1;
      object-fit: cover;
    }
    .gr-main-img-60 {
      width: 60vw !important;
      object-position: 30% 85%;
    }
    .gr-split-img-lg-top {
      object-position: 100% 100%;
      width: 100%;
    }
    .gr-split-img-lg-btm {
      object-position: 100% 0%;
      width: 100%;
    }
  }
</style>
